import psHttp from '@patsnap/common-ps-http';
import { coreCopilotApiUrlPrefix } from 'library-@/config/constants';

export async function feedbackApi(params) {
    try {
        const { data } = await psHttp({
            url: `${coreCopilotApiUrlPrefix}/analytics/copilot/feedback`,
            method: 'POST',
            data: params,
            transformCode: true,
            headers: {
                'X-API-Version': '1.0',
            },
        });

        return data || {};
    } catch (err) {
        throw err;
    }
}
